// USER
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const GET_USER = 'GET_USER';
export const UPDATE_USER = 'UPDATE_USER';

// LOADING
export const LOADING_BAR_ENABLE = 'LOADING_BAR_ENABLE';
export const LOADING_BAR_DISABLE = 'LOADING_BAR_DISABLE';

// GLOBAL LIST
export const CLEAN_ON_UNMOUNT_TRUE = 'CLEAN_ON_UNMOUNT_TRUE';
export const CLEAN_ON_UNMOUNT_FALSE = 'CLEAN_ON_UNMOUNT_FALSE';

// PAD LIST
export const PAD_LIST_GET = 'PAD_LIST_GET';
export const PAD_LIST_CLEAN = 'PAD_LIST_CLEAN';
export const PAD_LIST_MAP_GET = 'PAD_LIST_MAP_GET';
export const PAD_LIST_MAP_CLEAN = 'PAD_LIST_MAP_CLEAN';
export const UPLOAD_PAD_ITEM = 'UPLOAD_PAD_ITEM';

// USER LIST
export const USERS_LIST_GET = 'USERS_LIST_GET';
export const USERS_LIST_MAP_GET = 'USERS_LIST_MAP_GET';
export const USERS_LIST_CLEAN = 'USERS_LIST_CLEAN';
export const USERS_LIST_MAP_CLEAN = 'USERS_LIST_MAP_CLEAN';

// REVIEWS LIST
export const REVIEWS_LIST_GET = 'REVIEWS_LIST_GET';
export const REVIEWS_TOGGLE_REVIEW_STATUS = 'REVIEWS_TOGGLE_REVIEW_STATUS';
export const REVIEWS_REMOVE_REVIEW_REPORTED = 'REVIEWS_REMOVE_REVIEW_REPORTED';
export const REVIEWS_LIST_CLEAN = 'REVIEWS_LIST_CLEAN';

// MODERATION LIST
export const MODERATION_LIST_GET = 'MODERATION_LIST_GET';
export const MODERATION_LIST_CLEAN = 'MODERATION_LIST_CLEAN';

// USER FILTERS
export const GET_USER_FILTERS = 'GET_USER_FILTERS';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const ADD_NEW_FILTER = 'STORE_FILTER';

// REPORT PAGES
export const GET_PAD_SUBMISSIONS = 'GET_PAD_SUBMISSIONS';
export const GET_LOG_REPORTS = 'GET_LOG_REPORTS';
export const GET_DUPLICATE_REPORT = 'GET_DUPLICATE_REPORT';
export const GET_PAD_STATS_FAV = 'GET_PAD_STATS_FAV';
export const GET_PAD_STATS_VIEWS = 'GET_PAD_STATS_VIEWS';
export const CLEAN_REPORTS = 'CLEAN_PAD_SUBMISSIONS';
export const GET_UNDEFINED_USER = 'GET_UNDEFINED_USER';
export const GET_PILOTS_COUNTRY = 'GET_PILOTS_COUNTRY';
export const GET_PADS_COUNTRY = 'GET_PADS_COUNTRY';
export const GET_MODERATION_ENGAGEMENT = 'GET_MODERATION_ENGAGEMENT';
export const GET_SUBS_REPORT = 'GET_SUBS_REPORT';
export const GET_CONCURRENT_LOGINS_REPORT = 'GET_CONCURRENT_LOGINS_REPORT';
export const GET_SURVEYS_REPORT = 'GET_SURVEYS_REPORT';
export const GET_PILOT_AIRCRAFTS_REPORT = 'GET_PILOT_AIRCRAFTS_REPORT';
export const GET_PILOT_LANDING_REQUESTS = 'GET_PILOT_LANDING_REQUESTS';
export const GET_LIFECYCLE_OVERVIEW = 'GET_LIFECYCLE_OVERVIEW';
export const GET_VERIFICATION_SLA = 'GET_VERIFICATION_SLA';
export const GET_SCORE_QUALITY = 'GET_SCORE_QUALITY';
export const GET_EMAIL_DELIVERABILITY = 'GET_EMAIL_DELIVERABILITY';
export const GET_CROWD_EVIDENCE_IMPACT = 'GET_CROWD_EVIDENCE_IMPACT';
export const GET_VERIFICATION_QUEUE = 'GET_VERIFICATION_QUEUE';

// DUPLICATE LIST
export const DUPE_LIST_GET = 'DUPE_LIST_GET';
export const DUPE_LIST_CLEAN = 'DUPE_LIST_CLEAN';

// BOOTSTRAP
export const BOOTSTRAP = 'BOOTSTRAP';
export const BOOTSTRAP_PUSH = 'BOOTSTRAP_PUSH';

// CAMPAIGNS
export const GET_CAMPAIGNS_LIST = 'GET_CAMPAIGNS_LIST';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const REMOVE_CAMPAIGN = 'REMOVE_CAMPAIGN';

// ANNOUNCEMENTS
export const ANNOUNCEMENTS_LIST_GET = 'ANNOUNCEMENTS_LIST_GET';
export const ANNOUNCEMENTS_LIST_CLEAN = 'ANNOUNCEMENTS_LIST_CLEAN';
export const UPDATE_LOCAL_ANNOUNCEMENT_IN_LIST =
  'UPDATE_LOCAL_ANNOUNCEMENT_IN_LIST';
